// extracted by mini-css-extract-plugin
export default {"root":"B1HBPhi_"};